import { JSX } from "react";

export interface SectionTitleProps {
    title: string|JSX.Element
    icon: string|JSX.Element|null,
    subtitle?: string | null,
    subtitleClassName?: string | null
}

export default function SectionTitle({ title, subtitle, icon, subtitleClassName, ...props }: SectionTitleProps) {
  return (
    <div className="flex flex-col my-8 gap-2" data-testid={'section-title'} {...props}>
      <div className="flex items-center gap-4">
        {typeof icon === 'string' ? <img src={icon} alt='icon' className='size-5' /> : icon}
        <div className="text-2xl text-primary font-extrabold">{title}</div>
      </div>
      {subtitle
        ? subtitle.split('\n').map((line) => (
          <small key={line} className={subtitleClassName ?? ''}>{line} <br/></small>
        ))
        : null
      }
    </div>
  )
}